import { App, PlatformTypes, LinkAppTypes } from '../../api/appsApi';
import { useContext } from 'react';
import { useMarketingNotifications } from '../../../../shared-components/marketing-notification';
import AppsContext from '../../_contexts/AppsContext';

export default function TocMarketingNotifications({ moduleId }: { moduleId: string }) {
  const { apps } = useContext(AppsContext);

  const isNewDigibook = (app: App) =>
    app.platformType === PlatformTypes.P_INTERN && app.platformLinkType === LinkAppTypes.DIGIBOOK;

  const newDigibookApps = apps.filter(app => app.appType.isDigibook).filter(isNewDigibook);

  useMarketingNotifications({
    moduleId,
    newDigibookOnly: newDigibookApps.length > 0,
  });

  return null;
}
